import React, { useContext } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import Navbar from "../components/Navbar";
import { GlobalContext } from "../Context/GlobalState";
import VoiceAssistant from "./VoiceAssistant";

const DashboardLayout = () => {
  const { user } = useContext(GlobalContext);
  const userType =
    user?.us_type || JSON.parse(sessionStorage.getItem("user"))?.us_type || "E";

  return (
    <>
      <Navbar />
      <div
        style={{
          display: "flex",
          marginTop: "60px",
          height: "calc(100vh - 60px)",
        }}
      >
        <div
          style={{
            width: "230px",
            flexShrink: 0,
            overflow: "auto",
            scrollbarWidth: "none",
            height: "",
          }}
        >
          <Sidebar />
        </div>
        <div
          className="flex-grow-1 "
          style={{
            background: "#fff",
            overflow: "auto",
            scrollbarWidth: "none",
            overflowX: "hidden",
          }}
        >
          <Outlet />
        </div>
      </div>
      {/* <SiriWave /> */}
      {/* {userType === "A" && <VoiceAssistant />} */}
    </>
  );
};

export default DashboardLayout;
